import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SidebarTopbar from './layout';

export default function FAQPage() {
  const faqs = [
    {
      id: 1,
      question: 'What makes PubVision AI different from generic AI tools?',
      answer:
        'PubVision AI is purpose-built for medical publications. Unlike generic AI platforms, it understands scientific structure, clinical terminology, study designs, and medical data, enabling it to generate scientifically aligned, publication-based outputs without altering the original meaning.',
    },
    {
      id: 2,
      question: 'Does PubVision AI change, interpret, or hallucinate scientific content?',
      answer: 'No . PubVision AI extracts, restructures, and presents information strictly from the uploaded publication. It does not introduce new scientific claims or reinterpret data beyond what is stated in the source.',
    },
    {
      id: 3,
      question: 'How does PubVision AI handle different publication structures, journals, and therapeutic areas?',
      answer: 'PubVision AI recognizes common scientific structures across journals—such as abstracts, methods, results, figures, tables, and references—and adapts to complex and niche therapeutic content for consistent extraction and formatting.',
    },
    {
      id: 4,
      question: 'How does PubVision AI handle figures, graphs, and tables from publications?',
      answer: 'The platform automatically identifies and extracts figures, graphs, and key visual elements from the publication and adapts them for reuse across slides, posters, and other digital assets.',
    },
    {
      id: 5,
      question: 'Can I generate multiple outputs from the same publication?',
      answer: 'Yes. A single publication can be reused to generate multiple output formats without re-uploading the file. Credits are deducted per output type.',
    },
    {
      id: 6,
      question: 'How does the credit system ensure transparency and prevent accidental overuse?',
      answer: 'Before generation, users are shown the exact number of credits required for the selected output. Credits are deducted only after successful generation, ensuring full transparency and control.',
    },
    {
      id: 7,
      question: 'Is PubVision AI suitable for both internal and external scientific communication?',
      answer: 'Yes. PubVision AI supports internal medical education, congress materials, and digital scientific communication, subject to the copyright and permissions of the original publication.',
    },
    {
      id: 8,
      question: 'Can PubVision AI be used for congresses or time-sensitive projects?',
      answer: 'Yes. PubVision AI is particularly valuable for time-sensitive initiatives such as congress preparation, rapid scientific updates, and internal reviews.',
       
    },
    {
      id: 9,
      question: 'Does PubVision AI selectively summarise or highlight content?',
      answer: 'PubVision AI structures content based on relevance and clarity while maintaining fidelity to the source. Users retain full control to edit, refine, or rebalance emphasis after download.',
    },
    {
      id: 10,
      question: 'What should I do if the generated output needs refinement?',
      answer: 'All outputs except videos are fully editable after download, allowing teams to align content with internal standards, brand guidelines, and review feedback.',
    },
    {
      id: 11,
      question: 'How is my data protected within PubVision AI?',
      answer: 'All uploaded publications and generated content are handled securely and stored only in accordance with agreed NDA terms. Access is restricted to authorized users.'
    },
    {
      id: 12,
      question: 'Can PubVision AI scale across teams and multiple publications?',
      answer: 'Yes. PubVision AI supports collaboration across medical, scientific, and communication teams and is built to handle high-volume publication processing at an enterprise scale.'
    }
  ];

  return (
    <SidebarTopbar>
      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontFamily: "'Inter', sans-serif" }}>
          Frequently Asked Questions
        </Typography>
        <div style={{ paddingRight: '10px' }}>
          {faqs.map((item) => (
            <Accordion key={item.id} sx={{ fontFamily: "'Inter', sans-serif" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${item.id}-content`}
                id={`panel${item.id}-header`}
              >
                <Typography component="span" fontWeight="500" sx={{ fontFamily: "'Inter', sans-serif" }}>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontFamily: "'Inter', sans-serif" }}>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
        <Typography 
          variant="body2" 
          style={{ marginTop: '2rem' }}
          sx={{ fontFamily: "'Inter', sans-serif" }}
        >
          If you have any queries or suggestions, please shoot us an email at{' '}
          <Typography
            component="a"
            href="mailto:contact@pubvision.io"
            style={{ color: '#1E4DE3', textDecoration: 'underline' }}
          >
            contact@pubvision.io
          </Typography>
        </Typography>
      </div>
    </SidebarTopbar>
  );
}